import { Flex, Text } from "@chakra-ui/react";
import { DownloadDocumentIconButton } from "./DownloadDocumentIconButton/DownloadDocumentIconButton";

interface Props {
  attachment: { id: string; fileName?: string | null };
}

export const AttachmentRow = ({ attachment }: Props) => (
  <Flex align="center" justify="space-between" gap="2">
    <Text fontSize="sm" noOfLines={1}>
      {attachment.fileName || attachment.id}
    </Text>
    <DownloadDocumentIconButton documentId={attachment.id} size="sm" />
  </Flex>
);
